window.VegasCart = {
	add: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $self.data('id') || $product.data('id');
		let cnt = $product.find('input[name=cnt]').val() || 1;

		let params = VegasCart.formData({id: id, cnt: cnt});

		this.addRequest(params, function (data) {
			if (!data.error) {
				VegasCart.total(data, $product, cnt);
				$product.addClass('in-cart');

				VegasCart.popup($product.data('title'), true);
			}
		});
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback == 'function')
				callback(data);
		});
	},

	changeCnt: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $product.data('id');
		let pivot_id = $product.data('pivot_id');
		let cnt = $product.find('input[name=cnt]').val() || 1;
		let params = VegasCart.formData({
			id: id,
			pivot_id: pivot_id,
			cnt: cnt,
			get_products_totals: true,
		});

		$.post('/cart/change_product', params, function (data) {
			VegasCart.total(data);
		});
	},

	remove: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $product.data('id');
		let pivot_id = $product.data('pivot_id');
		let params = VegasCart.formData({
			id: id,
			pivot_id: pivot_id,
		});

		let rowsCount = parseInt($('.cart-table [data-cart=product]:visible').length) - 1;

		this.removeRequest(params, function (data) {
			VegasCart.total(data);

			$product.fadeOut('fast', function () {
				$product.remove();
			});

			if (rowsCount === 0) location.reload();
		});
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);
		});
	},

	total: function (data, $prd = false, cnt = false) {
		let $counter = $('[data-counter=cart]');

		if (typeof data.cnt !== 'undefined') {
			$counter.attr('data-cnt', data.cnt);
		}

		if (typeof data.order.calc.sums.summary !== 'undefined') {
			$('[data-cart-sum="basket"]').html(data.order.calc.formatted.summary);
		}

		if (typeof data.order.calc.sums.discountSum != 'undefined') {
			if (data.order.calc.sums.discountSum > 0) {
				$('.cart-discount').show();
				$('[data-cart-sum="discount"]').html(data.order.calc.formatted.discountSum);
			} else {
				$('.cart-discount').hide();
			}
		}

		this.totalProducts(data);
	},

	totalProducts: function (data) {
		if (typeof data.products_totals !== 'undefined') {
			$table = $('.cart-table');
			for (var id in data.products_totals) {
				let p = data.products_totals[id];

				$table.find('.row[data-cart="product"][data-id="' + id + '"]')
					.find('.total-cost')
					.html(p.sum_formatted);
			}
		}
	},

	updateTotalAll: function () {
		var params = $("#form-basket").serializeArray();

		$.get('/cart/get_totals', params, function (data) {
			VegasCart.total(data);
		});
	},

	formData: function (appendParams) {
		appendParams = appendParams || {};
		let resultParams = [];

		for (let name in appendParams) {
			resultParams.push({name: name, value: appendParams[name]});
		}

		resultParams.push({name: '_token', value: App.csrf});

		return resultParams;
	},

	popup: function (title) {
		let $modal = $('#modal-add-basket');

		$modal.find('h4.title').text("Товар \"" + title + "\" добавлен в корзину!");
		$modal.modal('show');
	},

	oneClick: function ($self) {
		let $product = $self.closest('[data-cart=product]'),
			$modal = $($self.data('target')),
			id = $product.data('id'),
			title = $product.data('title');

		$modal.find('.modal-title').html('Заказать ' + title);
		$modal.find('input[name=product_id]').val(id);

		$modal.modal('show');
	},

	activatePromocode: function($form, successCallback) {
		var route = $form.attr('action');
		var params = $form.serializeArray();

		$.post(route, params, function (data) {
			$modalPromocode = $("#modal-promocode");

			$pCont = $('.basket-discount-controls.promocode');

			if (!data.error) {
				$('#form-basket').find('input[name=with-promocode]').val(data.pid);

				if (data.msg) {
					$pCont.find('.msg')
						.removeClass('text-success')
						.removeClass('text-danger')
						.addClass('text-success')
						.text(data.msg)
						.show()
					;
					$modalPromocode.find('.btn-make-order').show();
					$modalPromocode.find('.btn-use-promocode').hide();
				} else {
					$pCont.find('.msg').hide();
				}

				if (typeof successCallback == 'function') {
					successCallback();
				}
			} else {
				$pCont.find('.msg')
					.removeClass('text-success')
					.removeClass('text-danger')
					.addClass('text-danger')
					.text(data.msg)
					.show()
				;
			}
		});
	}
};

/**
 * Прослушиватели событий корзины
 **/
let $window = $(window),
	$body = $('body'),
	$document = $(document)
;

$document.on('click', '[data-cart=add]', function () {
	VegasCart.add($(this));
	return false;
});

$document.on('click', '[data-cart=remove]', function () {
	VegasCart.remove($(this), 1);
	return false;
});

$document.on('click', '[data-cart=one-click]', function () {
	VegasCart.oneClick($(this));
	return false;
});

$document.on('click', '[data-cart=count-items]', function () {
	let $self = $(this),
		sign = $self.data('sign'),
		$container = $self.closest('.vg-shop-cart-count-items'),
		$input = $container.find('input[name=cnt]'),
		cnt = $input.val() || 1;

	if (sign === 'minus') {
		if (cnt > 1) {
			cnt--;
		}
	} else {
		cnt++;
	}

	$input.val(cnt);

	VegasCart.changeCnt($self);

	return false;
});

$document.on('change', '.cart-table .p-checkbox', function () {
	VegasCart.updateTotalAll();
});

$document.on('submit', '#form-promocode', function () {
	VegasCart.activatePromocode($(this));
	return false;
});
